import { useEffect, useState } from 'react'
import { listPanelUsers, inviteUser } from '@/lib/api'
import type { PanelUser } from '@/types'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function AdminUsers() {
  const [users, setUsers] = useState<PanelUser[]>([])
  const [email, setEmail] = useState('')
  const [role, setRole] = useState('analyst')
  const [inviting, setInviting] = useState(false)

  useEffect(() => {
    listPanelUsers().then(setUsers)
  }, [])

  async function handleInvite() {
    if (!email) return
    setInviting(true)
    try {
      await inviteUser(email, role)
      setEmail('')
    } finally {
      setInviting(false)
    }
  }

  const columns: Column<PanelUser>[] = [
    { header: 'Email', cell: (u) => u.email },
    { header: 'Rol', cell: (u) => <Badge>{u.role}</Badge> },
    { header: 'Desde', cell: (u) => new Date(u.created_at).toLocaleDateString('es-CR') },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint="GET /admin/users" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Usuarios del panel</h1>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@connect.inc"
          style={{
            background: 'var(--surface-raised)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-sm)',
            color: 'var(--text-primary)',
            padding: '8px 12px',
            fontSize: 13,
            flex: 1,
            maxWidth: 280,
          }}
        />
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          style={{
            background: 'var(--surface-raised)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-sm)',
            color: 'var(--text-primary)',
            padding: '8px 12px',
            fontSize: 13,
          }}
        >
          <option value="analyst">analyst</option>
          <option value="admin">admin</option>
        </select>
        <button
          onClick={handleInvite}
          disabled={inviting || !email}
          style={{
            background: 'var(--surface-raised)',
            border: '1px solid var(--border-strong)',
            color: 'var(--text-primary)',
            borderRadius: 'var(--radius-sm)',
            padding: '8px 16px',
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          {inviting ? 'Invitando…' : 'Invitar'}
        </button>
      </div>

      <DataTable columns={columns} rows={users} getRowKey={(u) => u.email} />
    </div>
  )
}
